var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "product-tile u-no-link",
      class: _vm.tileClass,
      attrs: { href: _vm.product.url },
      on: { mouseover: _vm.enter, mouseleave: _vm.leave },
    },
    [
      _vm.image
        ? _c("div", { staticClass: "product-tile__image-wrapper" }, [
            _vm.isBestSeller && !_vm.horizontal
              ? _c(
                  "div",
                  {
                    staticClass: "product-tile__best-seller preheader badge_bs",
                    style: _vm.bs_cssVars,
                  },
                  [_vm._v("Best Seller")]
                )
              : _vm._e(),
            _vm.isNewProduct && !_vm.horizontal
              ? _c(
                  "div",
                  {
                    staticClass: "product-tile__best-seller preheader badge_np",
                    style: _vm.nr_cssVars,
                  },
                  [_vm._v("New Product")]
                )
              : _vm._e(),
            _vm.isNewProductRoast && !_vm.horizontal
              ? _c(
                  "div",
                  {
                    staticClass: "product-tile__best-seller preheader badge_nr",
                    style: _vm.nr_cssVars,
                  },
                  [_vm._v("New Roast")]
                )
              : _vm._e(),
            _vm.isSingleOrigin && !_vm.horizontal
              ? _c(
                  "div",
                  {
                    staticClass: "product-tile__best-seller preheader badge_so",
                    style: _vm.so_cssVars,
                  },
                  [_vm._v("Single Origin")]
                )
              : _vm._e(),
            _vm.isLimitedEdition && !_vm.horizontal
              ? _c(
                  "div",
                  {
                    staticClass: "product-tile__best-seller preheader badge_le",
                    style: _vm.so_cssVars,
                  },
                  [_vm._v("Limited Edition")]
                )
              : _vm._e(),
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.image.src,
                  expression: "image.src",
                },
              ],
              staticClass: "product-tile__image product-tile__image--orig",
              attrs: { alt: _vm.image.alt },
            }),
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.altImage.src,
                  expression: "altImage.src",
                },
              ],
              staticClass: "product-tile__image product-tile__image--hovered",
              attrs: { alt: _vm.altImage.alt },
            }),
            _vm.productBadge
              ? _c("div", { staticClass: "product-tile__badge" }, [
                  _c("div", { staticClass: "product-tile__badge__text" }, [
                    _vm._v(_vm._s(_vm.productBadge)),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      !_vm.horizontal
        ? _c(
            "div",
            { staticClass: "product-tile__content" },
            [
              _c("product-bottom-line", {
                attrs: {
                  "product-id": _vm.product.id,
                  "display-no-reviews": false,
                },
              }),
              _c("h3", { staticClass: "product-tile__title" }, [
                _vm._v(_vm._s(_vm.cleanTitle)),
              ]),
              _c(
                "div",
                { staticClass: "product-tile__details" },
                [
                  _vm.isOnSale
                    ? _c("p", { staticClass: "product-tile__price" }, [
                        _vm._v(_vm._s(_vm._f("money")(_vm.product.price))),
                        _c(
                          "span",
                          { staticClass: "product-tile__price__original" },
                          [_vm._v(_vm._s(_vm._f("money")(_vm.comparePrice)))]
                        ),
                      ])
                    : _vm.product.type === "Gift Card"
                    ? _c("p", { staticClass: "product-tile__price" }, [
                        _vm._v(
                          _vm._s(_vm._f("money")(_vm.product.price)) +
                            " - " +
                            _vm._s(_vm._f("money")(_vm.maxProductPrice))
                        ),
                      ])
                    : _c("p", { staticClass: "product-tile__price" }, [
                        _vm._v(_vm._s(_vm._f("money")(_vm.product.price))),
                      ]),
                  _vm.showRoastLevel
                    ? _c("product-roast", {
                        attrs: { level: _vm.getRoastLevel },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "product-tile__content" },
            [
              _vm.$mq !== "horizontal"
                ? _c("product-bottom-line", {
                    attrs: {
                      "product-id": _vm.product.id,
                      "display-no-reviews": false,
                    },
                  })
                : _vm._e(),
              _c("div", { staticClass: "product-tile__title-wrapper" }, [
                _c(
                  "h3",
                  {
                    staticClass: "product-tile__title product-tile__title-mini",
                  },
                  [_vm._v(_vm._s(_vm.cleanTitle))]
                ),
                _vm.product.type === "Gift Card"
                  ? _c("p", { staticClass: "product-tile__price" }, [
                      _vm._v(
                        _vm._s(_vm._f("money")(_vm.product.price)) +
                          " - " +
                          _vm._s(_vm._f("money")(_vm.maxProductPrice))
                      ),
                    ])
                  : _c("p", { staticClass: "product-tile__price" }, [
                      _vm._v(_vm._s(_vm._f("money")(_vm.product.price))),
                    ]),
              ]),
              _vm.showRoastLevel
                ? _c("product-roast", { attrs: { level: _vm.getRoastLevel } })
                : _vm._e(),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }